import moment from 'moment';

// Mirrors the backend arrears rule (utils/dueStrategies.js): a period's due is
// generated on the month's last working day and expires on arrearsDueDay of
// the following month, moved to Monday when it falls on a weekend. Working
// days are Monday–Friday (holidays are not modelled).
export const DEFAULT_ARREARS_DUE_DAY = 15;

export const lastWorkingDay = (month) => {
	const day = moment.utc(month).endOf('month').startOf('day');
	while (day.isoWeekday() > 5) day.subtract(1, 'days');
	return day;
};

export const nextWorkingDay = (date) => {
	const day = moment.utc(date).startOf('day');
	while (day.isoWeekday() > 5) day.add(1, 'days');
	return day;
};

/**
 * Next due of an arrears debt/credit for the "Próximo vencimiento" banner.
 * The next period follows the latest generated due by the periodicity; with
 * no dues yet it is the month of firstDueExpiration. Returns DD-MM-YYYY
 * strings, or null when there is nothing to anchor on.
 */
export const nextArrearsDue = (entity, dues = [], periodicityNumMonths = 1) => {
	const dated = dues.filter((due) => due && due.date);
	let period;
	if (dated.length > 0) {
		const latest = dated.reduce((a, b) => (moment.utc(b.date).isAfter(moment.utc(a.date)) ? b : a));
		period = moment.utc(latest.date).startOf('month').add(periodicityNumMonths || 1, 'months');
	} else if (entity && entity.firstDueExpiration) {
		period = moment.utc(entity.firstDueExpiration).startOf('month');
	} else {
		return null;
	}
	const dueDay = Number(entity && entity.arrearsDueDay) || DEFAULT_ARREARS_DUE_DAY;
	return {
		nextExpirationDate: nextWorkingDay(period.clone().add(1, 'months').date(dueDay)).format('DD-MM-YYYY'),
		generationDate: lastWorkingDay(period).format('DD-MM-YYYY'),
	};
};
